import { lud, rule } from "../core/rule";

export const userPermissions = {
  view: "user.view",
  create: "user.create",
  update: "user.update",
  assignmentsUpdate: "user.assignments.update",
  globalAccessUpdate: "user.globalAccess.update",
};

// The users page is ceo-level only; every action in it inherits that.
export const userGrants = {
  "user.view": rule(lud()),
  "user.create": rule(lud()),
  "user.update": rule(lud()),
  // which restaurants / branches a user is assigned to
  "user.assignments.update": rule(lud()),
  // the all-restaurants scope of a staff user (am, dm, dmm, menuSp, sales, feedus). ceo-level only; it widens
  // WHICH restaurants the user reaches, never what their role may do. The backend enforces the same rule.
  "user.globalAccess.update": rule(lud()),
};
